var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_2719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.09375,
    y: 0.194336,
    width: 26.898,
    height: 26.9413,
    rx: 13.449,
    transform: "rotate(-0.414533 0.09375 0.194336)",
    fill: "url(#paint0_linear_2992_2719)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.09375,
    y: 0.194336,
    width: 26.898,
    height: 26.9414,
    rx: 13.449,
    transform: "rotate(-0.414533 0.09375 0.194336)",
    fill: "url(#paint1_linear_2992_2719)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.191209 13.6647C0.137384 6.22521 6.11491 0.150772 13.5424 0.0970337C20.9699 0.0432952 27.0347 6.0306 27.0885 13.4701C27.1423 20.9095 21.1648 26.9839 13.7373 27.0377C6.30983 27.0914 0.245034 21.1041 0.191209 13.6647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2045 9.36824C11.1816 9.37073 11.159 9.37582 11.1373 9.38342C10.4536 9.60212 9.9711 9.98365 9.7126 10.4778C9.4541 10.9719 9.42516 11.549 9.54191 12.1343C9.77539 13.3049 10.583 14.5591 11.6005 15.6011C12.618 16.6431 13.8419 17.4741 15.0049 17.7103C15.5865 17.8284 16.1644 17.7919 16.6621 17.5225C17.1598 17.2532 17.5538 16.7547 17.7956 16.0445C17.8179 15.9779 17.8174 15.9057 17.7942 15.8394C17.7711 15.7731 17.7266 15.7167 17.6679 15.6792L15.4658 14.2986L15.461 14.2938C15.4501 14.2867 15.4388 14.2802 15.4272 14.2745C15.3948 14.2535 15.3588 14.2389 15.3211 14.2313C15.3179 14.2313 15.3147 14.2313 15.3115 14.2314C15.3035 14.2295 15.2955 14.228 15.2874 14.2267C15.2858 14.2267 15.2842 14.2268 15.2826 14.2268C15.2313 14.2241 15.1801 14.2346 15.1338 14.2572C15.117 14.2655 15.101 14.2755 15.0859 14.2868C15.076 14.2928 15.0664 14.2994 15.0572 14.3065C15.0539 14.3114 15.0508 14.3163 15.0477 14.3213C15.0357 14.3319 15.0246 14.3434 15.0143 14.3557L14.5372 14.8524C13.6624 14.413 12.9868 13.6708 12.3773 12.6657L12.8163 12.2182C12.8247 12.2105 12.8327 12.2023 12.8402 12.1936C12.8468 12.1874 12.8532 12.1808 12.8593 12.1739C12.8593 12.1723 12.8593 12.1707 12.8592 12.1691C12.8659 12.1628 12.8722 12.1563 12.8783 12.1494C12.8783 12.1478 12.8783 12.1462 12.8783 12.1446C12.8816 12.1398 12.8848 12.1348 12.8878 12.1298C12.891 12.1267 12.8942 12.1234 12.8973 12.1201C12.9008 12.112 12.904 12.1039 12.9068 12.0956C12.9068 12.094 12.9068 12.0924 12.9067 12.0907C12.9084 12.0875 12.91 12.0843 12.9115 12.081C12.9149 12.0746 12.918 12.0681 12.9209 12.0614C12.9228 12.0533 12.9244 12.0452 12.9256 12.037C12.9256 12.0354 12.9256 12.0338 12.9255 12.0321C12.9275 12.0224 12.9291 12.0127 12.9301 12.0028C12.9301 12.0012 12.9301 11.9996 12.9301 11.998C12.9304 11.9898 12.9303 11.9817 12.9299 11.9735C12.9299 11.9719 12.9299 11.9703 12.9299 11.9687C12.9301 11.9606 12.9301 11.9524 12.9297 11.9443C12.9297 11.9411 12.9297 11.9378 12.9296 11.9346C12.9283 11.9264 12.9266 11.9183 12.9247 11.9102C12.9247 11.9086 12.9247 11.907 12.9246 11.9054C12.9197 11.8869 12.9131 11.869 12.905 11.8518C12.905 11.8502 12.905 11.8486 12.905 11.847C12.8994 11.8335 12.8929 11.8205 12.8855 11.808L12.8806 11.7984C12.879 11.7968 12.8774 11.7952 12.8757 11.7936L11.4892 9.51835C11.4623 9.47364 11.4248 9.43651 11.3801 9.41038C11.3353 9.38425 11.2849 9.36996 11.2333 9.36882C11.2237 9.36843 11.2141 9.3685 11.2045 9.36903L11.2045 9.36824ZM11.0989 10.0575L12.2325 11.9293L11.7696 12.4014C11.7225 12.4504 11.6926 12.5138 11.6844 12.5818C11.6762 12.6498 11.6902 12.7186 11.7243 12.7777C12.4449 14.0242 13.2951 14.9919 14.4795 15.5118C14.5362 15.5369 14.5991 15.5441 14.6599 15.5323C14.7207 15.5206 14.7766 15.4904 14.8203 15.4459L15.3118 14.9394L17.1276 16.0738C16.9307 16.5327 16.6718 16.807 16.3745 16.9679C16.0301 17.1543 15.6081 17.1922 15.1255 17.0942C14.1603 16.8981 12.9906 16.1372 12.0348 15.1584C11.079 14.1796 10.3362 12.9864 10.1419 12.0128C10.0448 11.526 10.0831 11.1058 10.258 10.7716C10.4085 10.4839 10.6659 10.2367 11.0989 10.0575Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.350716
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5862 5.75685C9.34339 5.78755 5.91986 9.31384 5.95106 13.6253C5.96239 15.192 6.43006 16.6531 7.24504 17.9035L6.40595 20.8255C6.38795 20.8882 6.38734 20.9547 6.40418 21.0178C6.42102 21.0809 6.45466 21.138 6.5014 21.1829C6.54814 21.2278 6.60616 21.2587 6.66909 21.2723C6.73202 21.2859 6.7974 21.2815 6.85806 21.2598L9.66061 20.2545C10.8358 20.9795 12.2224 21.3931 13.6993 21.3824C17.9438 21.3517 21.3656 17.8253 21.3345 13.514C21.3033 9.20265 17.8307 5.72614 13.5862 5.75685ZM13.5914 6.467C17.4582 6.43902 20.6069 9.59137 20.6353 13.5191C20.6637 17.4467 17.5609 20.6443 13.6941 20.6723C12.2924 20.6824 10.9857 20.2743 9.89047 19.5637C9.84569 19.5347 9.79498 19.5164 9.7422 19.5102C9.68942 19.504 9.63595 19.5102 9.58586 19.5282L7.26817 20.3595L7.9622 17.9425C7.97677 17.8918 7.98001 17.8384 7.97167 17.7862C7.96333 17.734 7.94364 17.6844 7.91402 17.6409C7.11559 16.4694 6.66092 15.1014 6.6502 13.6202C6.62178 9.69266 9.72641 6.49496 13.5914 6.467Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.350716
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2992_2719",
    x1: 13.5427,
    y1: 0.194336,
    x2: 13.5427,
    y2: 27.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FBD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2992_2719",
    x1: 13.5427,
    y1: 0.194336,
    x2: 13.5427,
    y2: 27.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FBD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139112"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_2719"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.09375,
    y: 0.194336,
    width: 26.898,
    height: 26.9413,
    rx: 13.449,
    transform: "rotate(-0.414533 0.09375 0.194336)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhatsapp);
export default __webpack_public_path__ + "static/media/ic_whatsapp.984062ba93dae72edf932d10f306ea7d.svg";
export { ForwardRef as ReactComponent };